import React from 'react';
import AuthScreen from '../components/auth/AuthScreen';

/**
 * `/forgot-password` — two ways back in: an emailed link, or a code texted to a number verified
 * in Settings (the one path that survives a lost inbox). Both live in components/auth/AuthScreen.
 */
export default function ForgotPasswordPage() {
  return <AuthScreen screen="forgot" />;
}
